module.exports = __webpack_public_path__ + "img/北京库房.2813d773.jpg";